import React, { Component } from 'react'
import './designerproject.scss'
//import { Button, Tags } from '@/components/ui'
class DesignerProject extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let classes = ['vbui--designerproject', this.props.classes, this.props.state].join(' ')
		return (
			<div className={classes}>
				<div className="anchor-row">
					<div className="floating-col">
						<p className="project-name">{this.props.projectNAME}</p>
					</div>
					<div className="project-col">
						<div className="img-container">
							<img src={this.props.projectIMG} alt="" />
						</div>
					</div>
					<div className="designer-col">
						<div className="designer-info">
							<div className="img-container">
								<img src={this.props.designerIMG} alt="" />
							</div>
							<p className="intro">Diseño por</p>
							<p className="designer-name">{this.props.designerNAME}</p>
							<p className="designer-desc">{this.props.children}</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default DesignerProject
